import {ReactComponent as Logo} from '../../assets/svg/logo.svg';

export default function LogoSvg(props: any) {
	return (
		<Logo {...props}/>
	)
}